import { SVGProps } from 'react';

const IcComment = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath='url(#clip0_10281_4928)'>
        <path
          d='M7.5 8.25C6.67157 8.25 6 8.92155 6 9.75C6 10.5784 6.67157 11.25 7.5 11.25C8.32845 11.25 9 10.5784 9 9.75C9 8.92155 8.32845 8.25 7.5 8.25Z'
          fill='#1D2129'
        />
        <path
          d='M10.5 9.75C10.5 8.92155 11.1716 8.25 12 8.25C12.8284 8.25 13.5 8.92155 13.5 9.75C13.5 10.5784 12.8284 11.25 12 11.25C11.1716 11.25 10.5 10.5784 10.5 9.75Z'
          fill='#1D2129'
        />
        <path
          d='M16.5 8.25C15.6716 8.25 15 8.92155 15 9.75C15 10.5784 15.6716 11.25 16.5 11.25C17.3284 11.25 18 10.5784 18 9.75C18 8.92155 17.3284 8.25 16.5 8.25Z'
          fill='#1D2129'
        />
        <path
          fillRule='evenodd'
          clip-rule='evenodd'
          d='M3.75 0.75C1.67894 0.75 0 2.42894 0 4.5V15C0 17.0711 1.67894 18.75 3.75 18.75H3.75908L3.76606 22.2588C3.76666 22.5655 3.95393 22.8409 4.2389 22.9542C4.52386 23.0675 4.84912 22.996 5.06019 22.7735L8.87685 18.75H20.25C22.3211 18.75 24 17.0711 24 15V4.5C24 2.42894 22.3211 0.75 20.25 0.75H3.75ZM1.5 4.5C1.5 3.25736 2.50736 2.25 3.75 2.25H20.25C21.4927 2.25 22.5 3.25736 22.5 4.5V15C22.5 16.2427 21.4927 17.25 20.25 17.25H8.5545C8.3487 17.25 8.15197 17.3345 8.01038 17.4839L5.26233 20.3808L5.25759 17.9985C5.25677 17.5849 4.92122 17.25 4.5076 17.25H3.75C2.50736 17.25 1.5 16.2427 1.5 15V4.5Z'
          fill='#1D2129'
        />
      </g>
      <defs>
        <clipPath id='clip0_10281_4928'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IcComment;
